import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {MatingCowsFilterFormValues} from '../../types';

const tm = t('mating');
const minimumCowAgeCriteriaCode = 'MesiceOdNarozeni';

/** Validates the required fields in the mating cow filter form.
 * @param values Current mating cow filter form values.
 * @returns Validation errors keyed by form field.
 */
export const validate = (values: MatingCowsFilterFormValues): Errors<MatingCowsFilterFormValues> => {
    const validator = new EskotValidator(values);

    validator.nonEmpty('breederId', tm('breeder'));
    validator.nonEmpty('farmIds', tm('farms'));

    return validator.generateErrorsObject();
};

/** Creates a warning validator for the minimum cow age criterion.
 * @param minimumCowAgeInMonths Minimum age from the scoring parameters.
 * @returns A warning validator for the mating cow filter form.
 */
export const createWarn = (minimumCowAgeInMonths: number | null) =>
    (values: MatingCowsFilterFormValues): Errors<MatingCowsFilterFormValues> => {
        const minimumCowAge = values.criterias?.numberRanges[minimumCowAgeCriteriaCode];

        if (minimumCowAgeInMonths !== null
            && minimumCowAge?.selectedType === 'number'
            && minimumCowAge.minimum !== null
            && minimumCowAge.minimum <= minimumCowAgeInMonths) {
            return {
                criterias: {
                    numberRanges: {
                        [minimumCowAgeCriteriaCode]: tm('minimumFemaleAgeInMonthsTooltip', {
                            number: minimumCowAgeInMonths,
                        }),
                    },
                },
            };
        }

        return {};
    };
